import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(3, 0),
    padding: theme.spacing(2.5),
    overflowX: 'auto',
    borderRadius: 16,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.background.default
        : alpha(theme.palette.secondary.main, 0.05),
    boxShadow: 'none',
    '& > code': {
      display: 'block',
      padding: 0,
      backgroundColor: 'transparent',
      color: theme.palette.text.primary,
      fontFamily:
        "SFMono-Regular, Consolas, 'Liberation Mono', Menlo, monospace",
      fontSize: 14,
      lineHeight: 1.7,
      whiteSpace: 'pre'
    }
  }
}));

function Pre({ className, ...rest }) {
  const classes = useStyles();

  return <pre className={clsx(classes.root, className)} {...rest} />;
}

Pre.propTypes = {
  className: PropTypes.string
};

export default Pre;
